import { h } from 'preact';
import { Card } from '../Card';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Card',
  category: '📋 Cards',
  description: 'Container card com variante padrão e highlight',
  usedIn: ['AgentesPage', 'Integrations', 'ReferralDashboard', 'Profile'],
  example: () => (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
      <Card><div style={{ color: T.text }}>Card padrão</div></Card>
      <Card highlight><div style={{ color: T.text }}>Card highlight</div></Card>
    </div>
  ),
};
